export interface ChangeWorkOrderOperatorPriority {
	operatorPriority: number;
	workOrderId: number;
}

export class ChangeWorkOrderOperatorPriority implements ChangeWorkOrderOperatorPriority {
	constructor(data?: Partial<ChangeWorkOrderOperatorPriority>) {
		if (data) {
			for (const key of Object.keys(data)) {
				(this as any)[key] = (data as any)[key];
			}
		}
	}
}
